var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuickShip = function SvgQuickShip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#QuickShip_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.323 8.188.945 7.785c-.444-.045-.737-.248-.88-.61-.143-.363-.05-.678.277-.947L7.701.215a.696.696 0 0 1 .293-.161 1.84 1.84 0 0 1 .5-.054c.328 0 .579.12.753.362.175.242.188.484.04.725L7.653 3.933l3.394.362c.465.054.764.262.896.624.132.363.034.678-.293.947l-7.264 5.92a.696.696 0 0 1-.293.16 1.916 1.916 0 0 1-.515.054c-.318 0-.566-.119-.746-.356-.18-.237-.195-.476-.047-.718l1.538-2.738Zm1.481-.46L8.5 5.5H5l.578-1.205L3 6.5h3l-.196 1.228Z",
    fill: "#0E3D7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "QuickShip_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgQuickShip;